jQuery(function($) {
  $('a[href^="#"]').click(function(event) {
    event.preventDefault();
    $('html,body').animate({scrollTop: $(this.hash).offset().top}, 500);
  });
  /*
  $('[role="menuitem"]').focus(function() {
    $('#' + $(this).attr('for')).prop('checked', true);
  });
  */
  $('header .menu-item-has-children').keydown(function(e) {
    if (e.keyCode === 40) { // down
      e.preventDefault();
      $(this).siblings('ul').addClass('focused');
      $(this).siblings('ul').find('li:first-child a').focus();
    }
    if (e.keyCode === 27) { // tab or esc
      $(this).blur();
    }
  });
  $('.subitem').keydown(function(e) {
    if (e.keyCode === 40) { // down
      e.preventDefault();
      $(this).parent().next('li').find('a').focus();
    }
    if (e.keyCode === 38) { // up
      e.preventDefault();
      $(this).parent().prev('li').find('a').focus();
    }
    if (e.keyCode === 9 || e.keyCode === 27) { // tab or esc
      $(this).closest('ul').removeClass('focused');
      $(this).blur();
    }
  });
  $('.subitem').focus(function() {
    $(this).closest('ul').addClass('focused');
  });
  $('body').mousedown(function() {
    $('.focused').removeClass('focused');
  });

  $('.list .em-search-ajax, .newslist .em-search-ajax').slick({
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  // Add functionality to change order between ASC and DESC
  // depending on future and past input
  $('.em-search-form').find('.tense input').click(function(e) {
    // past or future tense
    var order = $(e.currentTarget).val() === 'past' ? 'Desc' : 'Asc';
    $('#order' + order).trigger('click');
  });
});
